import { render, staticRenderFns } from "./MenuEditDialog.vue?vue&type=template&id=4d025463&scoped=true&"
import script from "./MenuEditDialog.vue?vue&type=script&lang=js&"
export * from "./MenuEditDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d025463",
  null
  
)

export default component.exports